<template>
  <popup-modal ref="popup">
    <DialogCloseButton :close-method="_reject" />

    <h2 class="font-weight-bold">
      {{ $t('FILE_STEP_PRODUCT.ASBESTOS_MODAL.TITLE') }}
    </h2>

    <div class="my-8">
      <v-radio-group v-model="selectedRadio" inline hide-details>
        <v-radio
          class="label-radio mr-10"
          color="#559a1b"
          :label="$t('COMMON.BUTTON.YES')"
          :value="true"
        />
        <v-radio
          class="label-radio"
          color="#559a1b"
          :label="$t('COMMON.BUTTON.NO')"
          :value="false"
        ></v-radio>
      </v-radio-group>
    </div>

    <div class="my-8" style="text-align: start">
      <p>
        {{ $t('FILE_STEP_PRODUCT.ASBESTOS_MODAL.MESSAGE') }}
      </p>
    </div>
    <div class="my-8" style="text-align: start">
      <p>
        {{ $t('FILE_STEP_PRODUCT.ASBESTOS_MODAL.MESSAGE_TWO') }}
      </p>
    </div>
    <v-file-input
      class="logo-selector"
      :label="$t('FILE_STEP_PRODUCT.ASBESTOS_MODAL.PLACEHOLDER')"
      chips
      counter
      show-size
      required
      v-model="file"
      :disabled="selectedRadio === false"
    >
      <template v-slot:append-inner>
        <img alt="download-icon" class="download-svg mr-4" src="@/assets/icons/file/download.svg" />
      </template>
    </v-file-input>

    <div class="d-flex justify-center">
      <v-btn
        :disabled="selectedRadio === null"
        class="boom-button pl-15 pr-15"
        variant="outlined"
        @click="_confirm"
      >
        {{ $t('COMMON.BUTTON.CONTINUE') }}
      </v-btn>
    </div>
  </popup-modal>
</template>

<script>
import PopupModal from '@/components/modal/PopupModal.vue'
import DialogCloseButton from '@/components/modal/DialogCloseButton.vue'

export default {
  name: 'AsbestosSheetModal',
  components: { DialogCloseButton, PopupModal },
  data: () => ({
    resolvePromise: undefined,
    rejectPromise: undefined,
    selectedRadio: null,
    file: ''
  }),

  methods: {
    show() {
      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    _confirm() {
      this.$refs.popup.close()
      this.resolvePromise({
        confirmed: true,
        selectedRadio: this.selectedRadio,
        file: this.file
      })
    },
    async _reject() {
      this.resolvePromise({
        confirmed: false
      })
      this.$refs.popup.close()
    }
  }
}
</script>

<style scoped>
:deep(.v-selection-control__input > .v-icon) {
  color: #559a1b;
  opacity: unset;
}

.label-radio {
  opacity: unset;
}

:deep(.v-selection-control-group--inline) {
  margin: auto;
}

:deep(.logo-selector .v-field.v-field--appended) {
  justify-content: center !important;
  align-content: center;
}

:deep(.v-selection-control--inline .v-label) {
  opacity: unset;
}

.download-svg {
  height: 20px;
  filter: invert(98%) sepia(0%) saturate(1853%) hue-rotate(181deg) brightness(96%) contrast(80%);
}
</style>
